import { Controller } from 'react-hook-form';
import * as S from './style';
import * as CS from '../style';
import InputWrapper from '../InputWrapper';
import {
  createFilterOptions,
  AutocompleteProps
} from '@mui/material/Autocomplete';
import { useState } from 'react';

export type IAutoCompleteProps = {
  id: string;
  options: Array<{ value: string; label: string }>;
  getOptionLabel: (option: { value: string; label: string }) => string;
  listItemProps: (option: { value: string; label: string }) => {
    key: string;
    label: string;
  };
  error?: string;
  placeholder: string;
  disabled?: boolean;
} & AutocompleteProps<any, any, any, any>;

const AutoComplete = (props: IAutoCompleteProps) => {
  const {
    id,
    options,
    getOptionLabel,
    listItemProps,
    error,
    placeholder,
    disabled,
    onChange,
    ...rest
  } = props;

  const filterOptions = createFilterOptions({
    ignoreCase: true,
    ignoreAccents: true,
    matchFrom: 'any',
    limit: 100,
    stringify: (option: { value: string; label: string }) => option?.label || ''
  });

  const [isFocused, setIsFocused] = useState(false);

  return (
    <InputWrapper {...props}>
      <S.StyledAutocomplete
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(option, value) => option.value === value?.value}
        onChange={onChange}
        filterOptions={filterOptions}
        renderOption={(_props, option) => (
          <li {..._props} key={listItemProps(option)?.key}>
            {listItemProps(option)?.label}
          </li>
        )}
        renderInput={(params) => (
          <CS.StyledTextField
            {...params}
            error={!!error}
            placeholder={placeholder}
            disabled={disabled}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        )}
        open={isFocused}
        disabled={disabled}
        {...rest}
      />
    </InputWrapper>
  );
};

export type ControllerAutoCompleteProps = {
  control: any;
  name: string;
  label?: string;
  placeholder: string;
  disabled?: boolean;
  options: Array<{ value: string; label: string }>;
  listItemProps: (option: { value: string; label: string }) => {
    key: string;
    label: string;
  };
};

export const ControllerAutoComplete: React.FC<ControllerAutoCompleteProps> = ({
  control,
  name,
  label,
  placeholder,
  disabled = false,
  options,
  listItemProps
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <AutoComplete
            label={label}
            id={name}
            options={options}
            getOptionLabel={(option) => option.label}
            listItemProps={listItemProps}
            value={options.find((option) => option.value === value) || null}
            onChange={(_, newValue) => {
              onChange(newValue ? newValue.value : null);
            }}
            placeholder={placeholder}
            error={error?.message || ''}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
